import { Navigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { useState } from "react";
import { Tokens } from "@okta/okta-auth-js";
import CustomLogin from "../components/CustomLogin/CustomLogin";

const Login: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [corsErrorModalOpen, setCorsErrorModalOpen] = useState(false);

  const onSuccess = (tokens: Tokens) => {
    if (tokens) {
      oktaAuth.handleLoginRedirect(tokens);
    }
  };

  const onError = (err: any) => {
    console.error("Login error:", err);
  };

  const login = async () => {
      oktaAuth.signInWithRedirect({ originalUri: '/' });
  };

  if (!authState) return <div>Loading...</div>;
  if (authState.isAuthenticated) return <Navigate to="/" />;

  // return <OktaSignInWidget onSuccess={onSuccess} onError={onError} setCorsErrorModalOpen={setCorsErrorModalOpen} />;
  return <CustomLogin login={login}/>
};

export default Login;
